import { Send } from "lucide-react"
import { type FormEvent, useState } from "react"

import { Button } from "@/components/ui/button"
import { Spinner } from "@/components/ui/spinner"

export function MessageComposer({
  disabled,
  onSubmit,
}: {
  disabled: boolean
  onSubmit: (prompt: string) => Promise<boolean>
}) {
  const [prompt, setPrompt] = useState("")

  async function submit(event: FormEvent) {
    event.preventDefault()
    const question = prompt.trim()
    if (!question || disabled) return

    if (await onSubmit(question)) setPrompt("")
  }

  return (
    <form
      onSubmit={(event) => {
        void submit(event)
      }}
      className="border-t p-3"
    >
      <label htmlFor="finance-agent-prompt" className="sr-only">
        Ask about your finances
      </label>
      <div className="flex items-end gap-2">
        <textarea
          id="finance-agent-prompt"
          value={prompt}
          onChange={(event) => setPrompt(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter" && !event.shiftKey) {
              event.preventDefault()
              event.currentTarget.form?.requestSubmit()
            }
          }}
          placeholder="Ask about your finances"
          rows={2}
          maxLength={2000}
          disabled={disabled}
          className="border-input bg-background focus-visible:border-ring focus-visible:ring-ring/50 min-h-16 flex-1 resize-none rounded-md border px-3 py-2 text-sm outline-none focus-visible:ring-3 disabled:opacity-50"
        />
        <Button
          type="submit"
          size="icon-lg"
          aria-label="Send"
          disabled={disabled || !prompt.trim()}
        >
          {disabled ? <Spinner /> : <Send />}
        </Button>
      </div>
      <p className="text-muted-foreground mt-2 text-xs">
        Read-only answers based on your recorded finances. Verify important
        decisions independently.
      </p>
    </form>
  )
}
